"use strict";

exports.__esModule = true;
exports.default = void 0;

var _sectionType = _interopRequireDefault(require("./sectionType"));

var _sectionText = _interopRequireDefault(require("./sectionText"));

var _sectionMedia = _interopRequireDefault(require("./sectionMedia"));

var _sectionEkultur = _interopRequireDefault(require("./sectionEkultur"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = {
  "type": "object",
  "properties": {
    "sectionType": _sectionType.default,
    "title": {
      "type": "localizedString"
    },
    "titleHidden": {
      "type": "boolean"
    }
  },
  "dependencies": {
    "sectionType": {
      "oneOf": [_sectionText.default, _sectionMedia.default, _sectionEkultur.default]
    }
  }
};
exports.default = _default;
module.exports = exports.default;